import React, { useState, useEffect } from 'react'
import { Loader } from 'semantic-ui-react'
import { useParams } from 'react-router-dom'
import ClientViewBid from '../../components/View/ClientViewBid'
import Signin from '../signin'
import { post } from '../../utils/apiClient'

export default function ViewBid() {
  const params = useParams()
  const [state, setState] = useState({
    loading: true,
    bid: null,
    viewBid: null
  })

  const mount = () => {
    async function fetchData() {
      const { uid } = params
      // todo: add check if uuid before sending request
      let res = await post('/api/view/bid', { data: { uid, definition: true } })
      if (res) {
        setState({
          ...state,
          loading: false,
          bid: res.bid ? res.bid : {},
          viewBid: res.viewBid,
          definition: res.definition || {}
        })
      }
    }
    fetchData()
    window.scrollTo(0, 0)
    const unmount = () => post.completeRequest(false)
    return unmount
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(mount, [])

  const { bid, viewBid } = state
  if (state.loading) {
    return (
      <div>
        <Loader active inline="centered">
          Loading
        </Loader>
      </div>
    )
  } else if (!bid.uid) {
    return <Signin />
  }

  return (
    <div className="client-app">
      <div className="app-container" id="app-layout">
        <div className="content-container">
          <div className="flex-side-bar" />
          <div className="flex-content">
            <div id="app-messages-content" />
            <ClientViewBid clientBid={bid} viewBid={viewBid} />
          </div>
        </div>
      </div>
    </div>
  )
}
